<div [class]="label ? 'sort-select-label' : 'sort-select'" appClickOutside (clickOutside)="onClickOutside()">
  <div class="input-wrapper">

    <input
      class="selected-item"
      [class.invalid]="invalid || error"
      [class.disabled]="disabled"
      autocomplete="off"
      [class.active]="dropdownToggle"
      (input)="openDropdown()"
      (pointerdown)="onPointerDown()"
      (focus)="onFocus()"
      (blur)="onBlur()"
      (keydown)="onKeyDown($event)"
      (click)="openDropdown()"
      type="text"
      [placeholder]="selectedOption?.label ?? placeholder"
      [(ngModel)]="inputText"
      (ngModelChange)="onNgModelChange($event)"
      name="search-select"
      [readonly]="!editable || (isMobile$ | async)"
      [disabled]="disabled"
      #searchInput
    />
    <label class="label" *ngIf="label">{{ label }}</label>
    <div class="icon-down_small" [class.invalid]="invalid || error" (click)="toggleDropdown()"></div>
  </div>
  <ng-template #dropdown>
    <ul
      class="dropdown scrollbar"
    >
      <li class="item clickable" [class.active]="selectedOption === option"
        *ngFor="let option of filteredOptions let index = index" (click)="optionClick(option)" #dropdownElement>
        {{ option.label }}
      </li>
      <li class="item" *ngIf="filteredOptions.length === 0">No results found.</li>
    </ul>
  </ng-template>
</div>
